import { AfterViewChecked, Component } from '@angular/core';
import 'prismjs' ;  // Import PrismJS
import 'prismjs/components/prism-python.min.js'; // For Python syntax highlighting (you can import other languages if needed)
// src/prism.d.ts or src/app/prism.d.ts
declare var Prism: any;

@Component({
  selector: 'app-markdown',
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.less',
})
export class MarkdownComponent implements AfterViewChecked{

  markdownContent = "### Domain Validation (DV) SSL Certificate Installation for alpha1.com\n\nIt seems that there is no SSL certificate installed for the domain alpha1.com. Let's proceed with installing a free DV SSL certificate using Certbot for the Apache web server.\n\nHere are the step-by-step instructions to install the SSL certificate:\n1. **Install Certbot:**\n   - Run the following commands in your terminal:\n     ```\n     sudo apt update\n     sudo apt install certbot python3-certbot-apache\n     ```\n\n2. **Obtain and Install the Certificate:**\n   - Run the following command to obtain and install the certificate:\n     ```\n     sudo certbot --apache -d alpha1.com\n     ```\n\n3. **Verify Installation:**\n   - After running the command, Certbot will guide you through the installation process. Once completed, you can verify the installation by visiting https://alpha1.com and checking for the padlock icon in the browser's address bar.\n\nPlease follow these steps to secure your website with an SSL certificate. Let me know if you need any further assistance or encounter any issues during the installation process.";

  ngAfterViewChecked(): void {
      Prism.highlightAll();
  }

}
